export function aboutUs() {
    $('#slider-about-us .slide-tab').on('click', function () {
        var _tab = $(this).data('chef');
        $(this).hide();
        $('.slide-tab').hide();
        $('.slide-tab').not($('#slider-about-us .slide-tab[data-chef="'+ _tab +'"]')).show();
        $('.slider-about-us .chef').removeClass('active');
        $('#' + _tab).addClass('active');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/about-us.js